import { getIsBankAvailableByIban, getYoIdBanksAvailable } from '@/utils/yoIdBanksAvailables';
import { extend } from 'vee-validate';
import { required, size, ext } from 'vee-validate/dist/rules';

const allowedExt = 'pdf,doc,docx,jpg,jpeg,png';

extend('requiredBankDocument', {
    ...required,
    message:
        '* Para confirmar la cuenta bancaria será necesario que adjunte el certificado de titularidad.'
});
extend('size', { ...size, message: '* El tamaño del documento no puede superar los 5MB.' });
extend('ext', {
    ...ext,
    message: `* El formato del documento no es válido, solo se aceptan .${allowedExt.split(',').join(', .')}`
});

export default {
    name: 'BankAccountDocumentOwnership',

    props: {
        bankAccount: {
            type: Object,
            required: true
        },
        showOperationsAdvice: {
            type: Boolean,
            default: false
        }
    },

    components: {},

    data() {
        return {
            bankAccountDocument: null,
            isInvalidDocumentFormat: false,
            isInvalidDocumentSize: false,
            maxSizeInBytes: 5000000, // 5MB
            yoIdBanksAvailable: []
        };
    },

    computed: {
        fileRules() {
            const sizeKB = Math.floor(this.maxSizeInBytes / 1024);
            const requiredPrefix = this.isNeedBankAccountDocument ? 'requiredBankDocument|' : '';

            return `${requiredPrefix}ext:${allowedExt}|size:${sizeKB}`;
        },

        isBankAvailableByIban() {
            const isBankAvailable = getIsBankAvailableByIban(
                this.bankAccount.iban_code,
                this.yoIdBanksAvailable
            );

            return isBankAvailable;
        },

        isNeedBankAccountDocument() {
            const hasYoidEnabled = this.$store.getters.getHasYoidEnabled;
            if (!hasYoidEnabled) return true;
            if (!this.bankAccount.iban_code) return false;

            return (
                !this.isBankAvailableByIban &&
                !this.bankAccount.uuid_intervener &&
                !this.bankAccount.is_validated
            );
        }
    },

    watch: {
        isNeedBankAccountDocument(newVal) {
            if (!newVal) {
                this.bankAccountDocument = null;
            }
        }
    },

    async mounted() {
        this.yoIdBanksAvailable = await getYoIdBanksAvailable();
    },

    methods: {
        onFileChange(file) {
            if (!file) {
                return;
            }

            this.$emit('on:fileSelected', file);
        }
    }
};
